/*
	页面相关api
**/
import $axios from "@/service/httpServer";
// 获取我的页面列表
export const getMyPages = p => $axios.post('/Web/Backend/ProgramTemplate/page', p);
// 获取我的页面详情
export const getPageDetail = p => $axios.get('/Web/Backend/ProgramTemplate/info', p);
// 新增页面
export const createPage = p => $axios.post('/Web/Backend/ProgramTemplate/add', p);

// 更新页面
export const updatePage = p => $axios.post('/Web/Backend/ProgramTemplate/update', p);

// 删除页面
export const deletePage = p => $axios.post('/Web/Backend/ProgramTemplate/delete', p);

export const copyProgram = p => $axios.post('/Web/Backend/ProgramTemplate/copy', p);

export const publishProgram = p => $axios.post('/Web/Backend/ProgramTemplate/publish', p);
export const prePublishProgram = p => $axios.post('/Web/Backend/ProgramTemplate/prePublish', p);

// 添加页面分类信息
export const addPageCategory = p => $axios.post('/Web/Backend/ProgramCategory/add', p);
// 删除页面分类信息
export const delPageCategory = p => $axios.post('/Web/Backend/ProgramCategory/delete', p);
// 获取页面分类信息
export const getPageCategory = () => $axios.post('/Web/Backend/ProgramCategory/list');
// 保存页面分类信息
export const saveAllCategory = (postData) => $axios.post('/Web/Backend/ProgramCategory/saveAllCategory', postData);
// 修改页面分类名称
export const editPageCategory = p => $axios.post('/Web/Backend/ProgramCategory/rename', p);

